import { Component, Input } from '@angular/core';
import { TransactionStatus } from '../../../api/transactions-api.service';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-transaction-status',
  templateUrl: './transaction-status.component.html',
  styleUrls: ['./transaction-status.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class TransactionStatusComponent {

  @Input() status?: TransactionStatus;

  constructor() { }
}
